import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';
import { CidadeDto, CidadeCreateDto, CidadeUpdateDto } from './cidade.model';

@Injectable({ providedIn: 'root' })
export class CidadeService {
  constructor(private api: ApiService) {}

  /** Public list — used to populate dropdowns and multi-select in forms */
  listAll(): Observable<CidadeDto[]> {
    return this.api.get<CidadeDto[]>('/public/cidades');
  }

  /** Admin paginated list */
  adminList(page = 1, pageSize = 20): Observable<{ data: CidadeDto[]; meta?: any }> {
    return this.api.get('/admin/cidades', { page, pageSize }) as Observable<any>;
  }

  get(id: string): Observable<CidadeDto> {
    return this.api.get<CidadeDto>(`/admin/cidades/${id}`);
  }

  create(payload: CidadeCreateDto): Observable<CidadeDto> {
    return this.api.post<CidadeDto>('/admin/cidades', payload);
  }

  update(id: string, payload: CidadeUpdateDto): Observable<CidadeDto> {
    return this.api.put<CidadeDto>(`/admin/cidades/${id}`, payload);
  }

  delete(id: string): Observable<void> {
    return this.api.delete<void>(`/admin/cidades/${id}`);
  }
}
